import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getRole(pathname, queryParams = "", headers = undefined) {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams, {
    headers,
  }); // pathname is "/role"
}

export async function createRole(pathname, body, queryParams = "") {
  return await instance({
    baseURL: baseURL,
  }).post("/role" + pathname + queryParams, body);
}

export async function updateRole(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch("/role" + pathname, body);
}

export async function addBulkPermissions(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/role" + pathname, body);
}

export async function addPermission(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/role" + pathname, body);
}

export async function deleteRole(pathname, queryParams = "") {
  return await instance({
    baseURL: baseURL,
  }).delete(`/role${pathname}${queryParams}`);
}
